/**
 * @description 季报头部组件 - 动态分发
 * 根据 year prop 选择对应年份版本的组件
 */
import React from 'react';
import Header2025 from '../../v1/components/QuarterReportHeader';
import Header2026 from '../../v2/components/QuarterReportHeader';

interface IQuarterReportHeaderProps extends IBaseProps {
  year?: number;
  isEN: boolean;
  reportDate?: string;
  report?: IQuarterReportDetails | null;
}

const QuarterReportHeader: React.FC<IQuarterReportHeaderProps> = ({ year, ...rest }) => {
  const Component = year === 2025 ? Header2025 : Header2026;
  return <Component year={year} {...rest} />;
};

export default QuarterReportHeader;
